










import { Component, Mixins, Prop } from "vue-property-decorator";
import Enumerable from "linq";
import {
  NavigationPane,
  IButtonState,
} from "../../../panes";
import { Patient } from "../../../../domain/patient";
import { ExternalMenuMixin } from "../../../system/mixins";
import ExternalMenuButton from "../../../system/ExternalMenuButton.vue";  // index.ts経由だと名前無しになるのでv-forで使えない
import { IExternalMenuItemConfiguration } from "../../../../domain/configuration";
import {
  IDocumentIdentifiable,
  DocumentSummaryHistory,
  DocumentSummary,
} from "../../../../domain/document";

@Component({
  components: {
    NavigationPane,
    ExternalMenuButton,
  },
})
export default class PatientExternalMenu extends Mixins(ExternalMenuMixin) {
  @Prop({ default: null })
  patient: Patient;

  @Prop({ default: () => [] as IExternalMenuItemConfiguration[] })
  items: IExternalMenuItemConfiguration[];

  @Prop()
  document: IDocumentIdentifiable;

  get buttons(): IButtonState[] {
    const source = this.createParameterSource();
    source.patientId = this.patient ? this.patient.id : null;
    source.documentId = this.document ? this.document.id : null;

    return Enumerable.from(this.items)
      .select(menu => {
        const buttonState = this.toButtonState(menu, !this.patient, source);
        if (!this.isVirtual) { return buttonState; }
        buttonState.isEnable = false;
        return buttonState;
      })
      .toArray();
  }

  get isVirtual(): boolean {
    return (this.document instanceof DocumentSummaryHistory || this.document instanceof DocumentSummary)
      && this.document.isVirtual;
  }
}
